import Helper from '../../../src/Helper.js';
import './style.scss';
import '../../../src/docReady.js';
import Dom from '../../../src/Dom.js';
import isMobile from '../../../src/isMobile.js';

const moduleSelector = '.eiovisual-configuratore';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo configuratore');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {

    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        
        // Tasks on images
        if(!isMobile.check()) {
            setTimeout(async () => { 
                
                new Promise(resolve => {
                    this.task1();
                });
                
                await this.task2();
            },0); // abilita effetto scrollmagic
        }
    }

    // _________________________________________________________________________

    /**
     * Sostituisce gli elementi .fit-text con elementi fit-text
     * @returns {undefined}
     */
    task1() {
    }

    // _________________________________________________________________________

    /**
     * Abilità ingresso con scroll della scritta fit-text
     */
    task2() {
    }

    // _________________________________________________________________________

}

// export
export default new Module();